import { actions } from './reducer'

export const {
  scroll,

  init,
  reset,
  setPath,
  setDataProject,
  setDataSections,
  setDataBlocks,
  setDataComments,
  setDataTasks,
  setScormSettings,
  setUrlParams,

  updateBlock,
  updateBlockVersion,
  remoteBlockPatch,
  addUndoPatch,
  undoBlock,
  redoBlock,
  resetBlock,
  waitBlock,

  setBlockViewed,
  setElement,
  setCourseNavigation,
  testStart,
  testEnd,
  testRestart,
  setQuestion,
  completeElement,
  questionValidate,
  questionReset,
  answerReset,
  continueBlock,
  hideBlock,
  continueAndHideBlock,
  setIncompleteElements,
  showIncompleteElementList,
  hideIncompleteElementList,
  setIncompleteSections,
  showNotCompletedSections,
  hideNotCompletedSections,
  sendCourseAnalytics,
  courseStart,
  courseContinue,
  courseEnd,
  setCourseStatus,
  setAppMode,
  setDeviceMode,
  setSidebar,
  setSidebarChapter,
  setSidebarSearch,
  setToolbar,
  setNavbar,
  setSettings,
  setCommentsFilter,
  setTasksFilter,
  setHighlight,
  setHighlightPreview,
  setProjectNavigation,
  // setAnalyticsViewedBlock,
  // setAnalyticsViewedBlocks,
  setScrollWait,
  clearScrollWait,
  setCommentForm,
  togglePinnedComment,
  setOpenedComment,
  setElementNavigation,
  setOpenedTask,
  setSyncing,
  sendReflection,

  setEmployeeToProjectPreferences,

  updateNodeStates,
  setShowGrid,
  updateNodeState,
  setOpenNode,
  playAnimation,
  dragStart,
  dragMove,
  dragEnd,
  setMetaKey,
  setShiftKey,
  setAltKey,
  setNodeTransformState,
  setAnchor,
  setMouseCoordinates,
} = actions
